import { render, staticRenderFns } from "./WindowControls.vue?vue&type=template&id=62e7f022&scoped=true"
import script from "./WindowControls.vue?vue&type=script&lang=js"
export * from "./WindowControls.vue?vue&type=script&lang=js"
import style0 from "./WindowControls.vue?vue&type=style&index=0&id=62e7f022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e7f022",
  null
  
)

export default component.exports